import { type UseQueryOptions, useQuery } from '@tanstack/react-query';
import { toString } from 'lodash';
import { ProjectConfigInterface } from 'src/interfaces';
import { queryKeys, requestCCApi } from 'src/utils';

import { mapProjectConfigs } from './helpers';

export const useGetProjectConfig = (
  configKey?: keyof ProjectConfigInterface,
  overrideQuerySetting?: UseQueryOptions<Partial<ProjectConfigInterface>>,
) =>
  useQuery({
    queryKey: configKey
      ? queryKeys.projectConfigs.details(configKey)
      : queryKeys.projectConfigs.all(),

    queryFn: () => fetchAllProjectConfigs(configKey),
    staleTime: Infinity,
    ...overrideQuerySetting,
  });

async function fetchAllProjectConfigs(
  configKey?: keyof ProjectConfigInterface,
) {
  const url = `/projectConfigs/${toString(configKey)}`;

  const response = await requestCCApi({
    url: url,
    params: {
      pageSize: 0,
    },
  });

  return mapProjectConfigs(response, configKey);
}
